import { Search } from "lucide-react";
import { STATUS_TABS, CAMPAIGNS, CAMPAIGN_STATUS } from "./campaign.data";

/**
 * Toolbar: status filter tabs (with live counts) + search input.
 */
export default function CampaignToolbar({ activeTab, onTabChange, search, onSearchChange }) {
  const countFor = (key) =>
    key === "all" ? CAMPAIGNS.length : CAMPAIGNS.filter((c) => c.status === key).length;

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
      {/* Status tabs */}
      <div className="flex items-center gap-1 overflow-x-auto rounded-xl bg-surface_alt p-1 border border-border">
        {STATUS_TABS.map((tab) => {
          const active = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors"
              style={
                active
                  ? { background: "var(--color-surface)", color: "var(--color-primary)", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }
                  : { color: "var(--color-text-muted)" }
              }
            >
              {tab.label}
              <span
                className="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                style={{
                  background: active ? "var(--color-primary-tint)" : "var(--color-border)",
                  color: active ? "var(--color-primary)" : "var(--color-text-muted)",
                }}
              >
                {countFor(tab.key)}
              </span>
            </button>
          );
        })}
      </div>

      {/* Search */}
      <div className="relative w-full lg:max-w-xs">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text_muted pointer-events-none" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search campaigns..."
          className="w-full pl-9 pr-4 py-2 text-sm rounded-xl bg-surface border border-border text-text_primary placeholder:text-text_muted focus:outline-none focus:border-primary transition-colors"
        />
      </div>
    </div>
  );
}

export { CAMPAIGN_STATUS };
